module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-auto-complete",
    class: {
      'fullWidth': _vm.fullWidth
    }
  }, [_c('text-field', {
    ref: "textField",
    attrs: {
      "value": _vm.searchText,
      "disabled": _vm.disabled,
      "inputClass": _vm.inputClass,
      "label": _vm.label,
      "labelFloat": _vm.labelFloat,
      "labelClass": _vm.labelClass,
      "labelFocusClass": _vm.labelFocusClass,
      "hintText": _vm.hintText,
      "hintTextClass": _vm.hintTextClass,
      "helpText": _vm.helpText,
      "helpTextClass": _vm.helpTextClass,
      "errorText": _vm.errorText,
      "errorColor": _vm.errorColor,
      "icon": _vm.icon,
      "iconClass": _vm.iconClass,
      "fullWidth": _vm.fullWidth,
      "underlineShow": _vm.underlineShow,
      "underlineClass": _vm.underlineClass,
      "underlineFocusClass": _vm.underlineFocusClass
    },
    on: {
      "focus": _vm.handleFocus,
      "input": _vm.handleInput,
      "blur": _vm.handleBlur
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.handleKeyDown($event)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('popover', {
    attrs: {
      "overlay": false,
      "autoPosition": false,
      "scroller": _vm.scroller,
      "open": _vm.open && _vm.list.length > 0,
      "trigger": _vm.anchorEl,
      "anchorOrigin": _vm.anchorOrigin,
      "targetOrigin": _vm.targetOrigin
    },
    on: {
      "close": _vm.handleClose
    }
  }, [(_vm.open) ? _c('mu-menu', {
    ref: "menu",
    staticClass: "mu-auto-complete-menu",
    style: ({
      'width': (_vm.menuWidth && _vm.menuWidth > _vm.inputWidth ? _vm.menuWidth : _vm.inputWidth) + 'px'
    }),
    attrs: {
      "maxHeight": _vm.maxHeight,
      "disableAutoFocus": _vm.focusTextField,
      "initiallyKeyboardFocused": "",
      "autoWidth": false
    },
    on: {
      "itemClick": _vm.handleItemClick
    },
    nativeOn: {
      "mousedown": function($event) {
        _vm.handleMouseDown($event)
      }
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('menu-item', {
      key: 'auto_' + index,
      staticClass: "mu-auto-complete-menu-item",
      attrs: {
        "disableFocusRipple": _vm.disableFocusRipple,
        "afterText": "",
        "leftIcon": item.leftIcon,
        "leftIconColor": item.leftIconColor,
        "rightIconColor": item.rightIconColor,
        "rightIcon": item.rightIcon,
        "value": item.value,
        "title": item.text
      },
      nativeOn: {
        "mousedown": function($event) {
          _vm.handleMouseDown($event)
        }
      }
    })
  })) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ac749ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/autoComplete/autoComplete.vue
// module id = 417
// module chunks = 1